export const SAVE_ALL_VEHICLE_USAGE_INFOS = 'SAVE_ALL_VEHICLE_USAGE_INFOS'
export const SAVE_VEHICLE_USAGE_INFO = 'SAVE_VEHICLE_USAGE_INFO'
